import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import HowTo from './pages/HowTo';
import Datenschutz from './pages/Datenschutz';
import Impressum from './pages/Impressum';
import NotFound from './pages/NotFound';
import CookieBanner from './components/CookieBanner';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/howto" element={<HowTo />} />
          <Route path="/howto.html" element={<HowTo />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/datenschutz.html" element={<Datenschutz />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/impressum.html" element={<Impressum />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
